/**
 * Handle Join Session button click
 * Opens join_url in new tab or shows error if no URL
 */
export function initJoinSession() {
	document.addEventListener("click", (e) => {
		const btn = e.target.closest('[data-action="join"]');
		if (!btn) return;

		const joinUrl = btn.dataset.joinUrl;

		if (joinUrl && joinUrl.trim() !== "") {
			window.open(joinUrl, "_blank");
		} else {
			if (typeof wpcore !== "undefined" && wpcore.showAlert) {
				wpcore.showAlert("error", wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'No join link available for this session.', fr: 'Aucun lien de connexion disponible pour cette session.' }));
			}
		}
	});
}
